import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives";

import { ConfluenceOverlayTemplate } from "@/components/signup/layouts";
import SiteActivation from "@/components/signup/site-activation";
import { useCohort, useNewUser } from "@/components/user-context";
import { experiments, useExperiment } from "@/utils/experiment";
import { FeatureExposed } from "@/utils/feature-exposed";

import {
    CreateAWorkspaceHeading,
    SubHeading,
    WelcomeBackHeading
} from "../../../components";

import { CurrentProductJoinableUser } from "./current-product-joinable-user";
import { CurrentProductUser } from "./current-product-user";

export const LoggedInConfluenceFree = () => {
    const isNewUser = useNewUser();

    const experiment = useExperiment(
        experiments.confluenceContactAndCompanyExpandSiteActivation
    );

    const useContactExpandCohortLogic =
        experiment.type === "enrolled" && experiment.value;

    const cohort = useCohort(useContactExpandCohortLogic);

    if (useContactExpandCohortLogic) {
        if (cohort === "current-product-user") {
            return <CurrentProductUser />;
        }

        if (cohort === "current-product-joinable-user") {
            return <CurrentProductJoinableUser />;
        }
    }

    return (
        <FeatureExposed
            experimentKey="cfind-3467-signup-with-image-overlay"
            group="isTreatment"
        >
            <ConfluenceOverlayTemplate size="sm">
                <div css={headerOffsetForBlueBackgroundCss}>
                    {isNewUser ? (
                        <>
                            <CreateAWorkspaceHeading />
                            <SubHeading>
                                <FormattedMessage
                                    id="BxpUiSignup.nameSite.subHeader.newWorkspaceSubHeader"
                                    defaultMessage="This is the URL for your team to access Confluence. Most people use their team or company name."
                                />
                            </SubHeading>
                        </>
                    ) : (
                        <>
                            <WelcomeBackHeading />
                            <SubHeading>
                                <FormattedMessage
                                    id="BxpUiSignup.nameSite.cobrandedSubHeader"
                                    defaultMessage="It’s free for up to 10 users - no credit card needed."
                                />
                            </SubHeading>
                        </>
                    )}
                </div>
                <SiteActivation
                    useContactExpandCohortLogic={useContactExpandCohortLogic}
                />
            </ConfluenceOverlayTemplate>
        </FeatureExposed>
    );
};

const headerOffsetForBlueBackgroundCss = css({
    marginBlockStart: 54,
    [media.above.sm]: {
        marginBlockStart: 0
    }
});
